import http from "@/utils/http";
/**
 * 收到的事项
 */
export const queryReceivedItemList = () => http.get('/business/queryReceivedItemList.htm?pageIndex=0&pageSize=10000')

/**
 * 发出的事项
 */
export const querySentItemList = () => http.post('/business/querySendItemList.htm?pageIndex=0&pageSize=10000&more=more')

/**
 * 事项总数
 */
export const queryTotalItemNum = () => http.get('/business/queryTotal.htm')


export const initiatedEximplPublicPage = () => http.get('/business/initiatedEximplPublicPage.htm')


/**
 * 事项重算
 */
export const recountTotalItemNum = () => http.get('/business/recountByLoginUser.htm')

/**
 * 待办事项重算，一次session只重算一次
 */
export const recountTodoItemNum = () => {
    const key = 'recountTodoItemNum'
    if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, 'true')
        http.get('/business/recountByLoginUserForToDo.htm')
    }
}

/**
 * 填报任务
 */
export const queryIssuedTaskList = (pageIndex) => http.get('/ybt/portal/queryAllTaskByUserId.htm', {
    pageIndex: pageIndex,
    pageSize: 20
})
/**
 * 任务详情
 */
export const queryIssuedTaskDetail = (taskId,groupId) => http.get('/ybt/portal/queryTaskDetail.htm', {
    taskId:taskId,
    groupId:groupId
})

/**
 * 我转办的
 */
export const queryMyTransferList = (pageIndex) => http.get('/cooperativeInst/queryShuffleCooperativeList.htm', {
    pageIndex: pageIndex,
    pageSize: 20
})